import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const Spinner = () => <Spin indicator={<LoadingOutlined />} spinning />;

export default Spinner;
